export default "__VITE_ASSET__CkknhPmQ__"